import {  AjaxObservable, AjaxCreationMethod  } from './AjaxObservable';

export const ajax: AjaxCreationMethod = AjaxObservable.create;


// WEBPACK FOOTER //
// ./~/rxjs/src/observable/dom/ajax.ts